import {GetCountryPopupResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/country_detection/v1/service.types';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';

export const CountryDetectionView: React.FC<
  GetCountryPopupResponse
> = props => {
  return (
    <>
      {props.type?.$case === 'international' && (
        <InternationalPopupContainer international={props.type.international} />
      )}
      {props.type?.$case === 'internal' && (
        <CountrySwitchPopupContainer
          targetCountry={props.type.internal.targetCountry}
          currentCountry={props.type.internal.currentCountry}
        />
      )}
      {/* Language switch currently relies on the CountrySwitch and InternationalPopup shown state internally */}
      {/* To avoid this we need to lift the state of CountrySwitch & InternationalPopup to CountryDetection view level */}
    </>
  );
};

const InternationalPopupContainer = lazy(() =>
  import('./InternationalPopup/InternationalPopupContainer').then(mod => ({
    default: mod.InternationalPopupContainer,
  })),
);

const CountrySwitchPopupContainer = lazy(() =>
  import('./CountrySwitchPopup/CountrySwitchPopupContainer').then(mod => ({
    default: mod.CountrySwitchPopupContainer,
  })),
);
